type GestureStyle = {
    width?: string | number
    height?: string | number
    flexGrow: number
    flexShrink: number
    flexBasis: string | number
    display?: 'flex'
    justifyContent?: 'center'
    alignItems?: 'center'
}

export function getGestureStyling(
    width?: number | string,
    height?: number | string,
    noExpand?: boolean,
    center?: boolean
): GestureStyle {
    return {
        width,
        height,
        flexGrow: noExpand ? 0 : 1,
        flexShrink: 1,
        flexBasis: noExpand ? 'auto' : 0,
        display: 'flex',
        justifyContent: center ? 'center' : undefined,
        alignItems: center ? 'center' : undefined,
    }
}
